export const getToken = () => {
  let token = null;
  try {
    const queryParams = new URLSearchParams(window.location.search);
    token = queryParams.get("t");
    if (!token) {
      token = JSON.parse(localStorage.getItem("authUser")).token;
    }
  } catch (error) {
    return null;
  }

  return token;
};
